import { BillManageResponseDTO } from '@/interface/KKC/billMgmt';
import { BoolString } from '@/interface/KKC/withdrawal';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  billMgmtRes: BillManageResponseDTO | null;
  isOpen: BoolString;
  stateHasChange: boolean;
}

const initialState: CommonState = {
  billMgmtRes: null,
  isOpen: BoolString.NO,
  stateHasChange: false,
};

const billMgmtSlice = createSlice({
  name: 'billMgmt',
  initialState,
  reducers: {
    setBillMgmtRes(
      state: any,
      action: PayloadAction<{ billMgmtRes: BillManageResponseDTO | null }>
    ) {
      state.billMgmtRes = action.payload.billMgmtRes;
    },
    setBillApplyIsOpen(state: CommonState, action: PayloadAction<{ isOpen: BoolString }>) {
      state.isOpen = action.payload.isOpen;
    },
    setBillMgmtStateHasChange(state: CommonState, action: PayloadAction<boolean>) {
      state.stateHasChange = action.payload;
    },
  },
  extraReducers: () => {
    // 异步action成功的reducer执行
  },
});

const { setBillMgmtRes, setBillApplyIsOpen, setBillMgmtStateHasChange } = billMgmtSlice.actions;

export { setBillApplyIsOpen, setBillMgmtRes, setBillMgmtStateHasChange };

export default billMgmtSlice.reducer;
